module.exports = __webpack_public_path__ + "img/add_col_before.85fa4a99.svg";